import _ from 'lodash'

class FilterEquationFormatter {

	constructor(options = {}) {
		this.dataset = options.dataset
	}

	/**
	 * Formats a column reference using data like this
	 *
	 * <pre>
	 * {
	 *  fieldId : 1234 // this is the field ID
	 * }
	 * </pre>
	 *
	 * So it's in a format like this:
	 *
	 * <pre>
	 * [Part Number]
	 * </pre>
	 *
	 * @param {Object} data
	 * @param {String} data.fieldId
	 */
	format (data) {
		if (_.isEmpty(_.get(data, 'fieldId'))) {
			return null
		}
		let label = this.dataset.getFieldLabel(data.fieldId)
		return `[${label}]`
	}

}

export default FilterEquationFormatter

FilterEquationFormatter.__filename__ = 'datasets/filters/filter-equation-formatter.js'
